import React from 'react'
import './Myself.css'
const Myself = () => {
  
  return (
    <>


      <div className="container bg-shape " id='myself'>
        <div className="row ">
       <h3 className='text-center mt-5 mb-5 hr-lines '>About Azeem Zafar</h3>
       <div className='intro2 col-lg-4 col-md-4 col-sm-4'>
             <img src="./images/mypic.jpeg" alt="mypic" className='img '/>
        </div>
        <div className=' intro col-lg-6 col-md-6 col-sm-6'>
       
     <span className='Line'>Who am i ?</span><h3>I am a Full Stack Web Developer and have Worked With Multiple Projects Using Multiple Technologies.</h3>
     <br />
     <div className="row">
      <div className="col-lg-5 col-sm-12 col-md-5">
      As a highly skilled and experienced Full Stack Web Developer, I have had the opportunity to work on various technologies, honing my skills and delivering exceptional web solutions. With a comprehensive understanding of both front-end and back-end development, I am adept at creating robust and user-friendly applications that meet the unique requirements of clients.
      </div>

      <div className="col-lg-5 col-sm-12 col-md-5">
      Moreover, I have collaborated with cross-functional teams, including designers, project managers, and other developers, to ensure successful project delivery. I am an effective communicator, capable of translating technical concepts into understandable terms, fostering effective teamwork and client satisfaction.
      </div>
     </div>
     <br />
     <h2>Experience & Education</h2>
         <hr />
         <div className="row">
      <div className="col-lg-7 col-sm-12 col-md-7">
    <h5>Bachelor in Computer Science</h5>
      </div>
      <div className="col-lg-3 col-sm-3 col-md-3">
    <h6>2018 - 2022</h6>
      </div>
     </div>
        <hr />
        <div className="row">
      <div className="col-lg-7 col-sm-12 col-md-7">
    <h5>Associate Software Engineer</h5>
      </div>
      <div className="col-lg-3 col-sm-3 col-md-3">
    <h6>2022 - Present</h6>
      </div>
     </div>
       </div>
       
       
       

       

  </div>
  
  </div>
     
    </>
  )
}

export default Myself
